export class SpatialGrid {
    constructor(cellSize) {
        this.cellSize = cellSize;
        this.grid = new Map();
    }

    // Generate unique key for a grid cell
    getCellKey(position) {
        const x = Math.floor(position.x / this.cellSize);
        const y = Math.floor(position.y / this.cellSize);
        const z = Math.floor(position.z / this.cellSize);
        return `${x},${y},${z}`;
    }

    // Add object to the grid
    addObject (object) {
        const key = this.getCellKey(object.position);
        if (!this.grid.has(key)) {
            this.grid.set(key, []);
        }
        this.grid.get(key).push(object);
    }

    // Remove an object from the grid
    removeObject(object) {
        const key = this.getCellKey(object.position);
        const cell = this.grid.get(key);
        if (cell) {
            const index = cell.indexOf(object);
            if (index !== -1) cell.splice(index, 1);
            if (cell.length === 0) this.grid.delete(key);
        }
    }

    // Get all the objects in nearby cells
    getNearbyObjects(position) {
        const x = Math.floor(position.x / this.cellSize);
        const y = Math.floor(position.y / this.cellSize);
        const z = Math.floor(position.z / this.cellSize);

        const nearbyObjects = [];
        for (let dx = -1; dx <= 1; dx++) {
            for (let dy = -1; dy <= 1; dy++) {
                for (let dz = -1; dz <= 1; dz++) {
                    const key = `${x + dx},${y + dy},${z + dz}`;
                    if (this.grid.has(key)) {
                        nearbyObjects.push(...this.grid.get(key));
                    }
                }
            }
        }
        return nearbyObjects
    }

    // Clear the grid
    clear(){
        this.grid.clear();
    }
}